class KinDiningUpsellProduct extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.quantityCounter = this.querySelector("[data-quantity-counter]");
    this.plus = this.querySelector("[data-quantity-plus]");
    this.minus = this.querySelector("[data-quantity-minus]");
    this.checkbox = this.querySelector("[data-selected]");
    this.quantitySelector = this.querySelector("[data-quantity-selector]");

    this.productFormCheckbox = document.querySelector(
      `[data-kin-dining-upsell-product='${this.productId}'][data-kin-dining-upsell-input='id']`
    );

    this.quantityInput = document.querySelector(
      `[data-kin-dining-upsell-product='${this.productId}'][data-kin-dining-upsell-input='quantity']`
    );

    if (this.quantityInput)
      this.quantity = parseInt(this.quantityInput.value) * 2;

    if (this.plus)
      this.plus.addEventListener("click", this.onQuantityIncrease.bind(this));

    if (this.minus)
      this.minus.addEventListener("click", this.onQuantityDecrease.bind(this));

    this.checkbox.addEventListener("change", (e) => this.onToggle(e));
  }

  onToggle(e) {
    this.productFormCheckbox.checked = e.target.checked;

    if (this.quantityInput) this.quantityInput.checked = e.target.checked;
    if (this.quantitySelector)
      this.quantitySelector.classList[e.target.checked ? "add" : "remove"](
        "visible"
      );

    if (!e.target.checked && this.quantity) this.setQuantity(2);
  }

  setQuantity(quantity) {
    this.quantity = quantity;
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity / 2;
  }

  onQuantityIncrease() {
    this.quantity += 2;
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity / 2;
  }

  onQuantityDecrease() {
    if (this.quantity === 2) {
      this.checkbox.click();
      return;
    }

    this.quantity = Math.max(2, this.quantity - 2);
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity / 2;
  }
}

if (!customElements.get("kin-dining-upsell-product")) {
  customElements.define("kin-dining-upsell-product", KinDiningUpsellProduct);

  // document.addEventListener("DOMContentLoaded", () => {
  //   const updatePrice = () => {
  //     const atc = document.querySelector(".product-form__submit span");
  //     const quantity = parseInt(
  //       document.querySelector("product-info .quantity__input")?.value || "1"
  //     );
  //     const selectedAddons = document.querySelectorAll(
  //       ".kin-dining-upsell__checkbox:checked"
  //     );

  //     const total = Array.from(selectedAddons).reduce((acc, el) => {
  //       const price = parseInt(el.dataset.price);
  //       const quantity =
  //         el.closest("kin-dining-upsell-product").quantity / 2 || 1;
  //       return acc + price * quantity;
  //     }, window.currentVariant.price * quantity);

  //     atc.dataset.total = window.formatMoney(total);
  //     atc.classList.add("total");
  //   };

  //   document
  //     .querySelector(".quantity__input")
  //     .addEventListener("change", updatePrice);

  //   document
  //     .querySelectorAll(
  //       "variant-radios .pill-item, .kin-dining-upsell__checkbox, .kin-dining-upsell__button, .quantity__button"
  //     )
  //     .forEach((el) => el.addEventListener("click", updatePrice));
  // });
}
